import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberLeaderboardPage from "@/pages/member/MemberLeaderboardPage";

export const Route = createFileRoute("/member/leaderboard")({
  head: () => pageHead("Member · Leaderboard", "AKIVA member · leaderboard portal.", "/member/leaderboard", true),
  component: MemberLeaderboardPage,
});
